import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
require.context('../images', true)
window.Routes = require('routes');
Routes.configure({
});
Routes.config()
Rails.start()
ActiveStorage.start()

import 'css/application.scss'
import 'css/style.scss'
import './sidebar'
import './filter_search'

import './floating_button';
import './sorting'